import { Id } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useMembers } from 'chat/members/queries/list'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { removeConversationFromCache } from './shared/utils'

export function useDeleteConversation(id: Id) {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()
  const membersQuery = useMembers(id, true)
  let memberIds: string[] = []
  if (membersQuery?.data) {
    memberIds = membersQuery.data?.map(member => member.id)
  }

  return useMutation({
    mutationFn: deleteConversation,
    onSuccess: async () => {
      await removeConversationFromCache(client, id)
      sendWebsocketMessage({
        action: 'conversationEvent',
        conversationEvent: {
          removedConversationId: id,
          memberIds,
        },
      })
    },
  })

  function deleteConversation() {
    return server.delete(`/v2/chat/conversations/${id}`)
  }
}
